import * as React from "react";
import { useEffect } from "react";
import api from "../../utils/api";
import reservationStore from "../../store/reservationStore";

import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import CardExpand from './CardExpand';
import * as util from "../../utils/util";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(0.5),
  textAlign: 'center',
  fontSize: 12,
  color: theme.palette.text.secondary,
}));

const hospitalParam = {
  cusId: '',
  famId: '',
  hosId: ''
}

const pakageParam = {
  famId: '',
  pkgId: ''
}

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const SetItem = (props: any) => {
  const storeData: any = reservationStore();
  const [isSatOpen, setIsSatOpen] = React.useState(true);
  const [selectHospital, setSelectHospital] = React.useState({
    name: '', address: '', buildingNum: '', phone: '', notice: '', plusInfo: '', fileName: '', region: '', operatingHours: ''
  });
  const [allItems, setAllItems] = React.useState([]);
  const [capacity, setCapacity] = React.useState([]);
  const [packagesInfo, setPackagesInfo] = React.useState([]);
  const [packageList, setPackageList] = React.useState([{ pkgId: '' }]);
  const [closePackageIds, setClosePackageIds] = React.useState<string[]>([])
  const [injectionData, setInjectionData] = React.useState([]);
  const [baseInjectionByCategory, setBaseInjectionByCategory] = React.useState<string[]>([])
  const [baseInjection, setBaseInjection] = React.useState(0);
  const [injectionPrice, setInjectionPrice] = React.useState(0);
  const [choiceList, setChoiceList] = React.useState([{ title: '', id: '', count: '' }]);
  const [showBaseInjection, setShowBaseInjection] = React.useState(false);
  const [checkedBoxes, setCheckedBoxes] = React.useState([[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
  const [closeEndoscopeItems , setCloseEndoscopeItems] = React.useState<string[]>([]);
  // 렌더 중에 읽는다 — JSON.parse 였을 때는 값이 없으면 화면 전체가 흰 화면이 됐다.
  // 되돌리는 처리는 마법사 진입 지점(ReservationStep)이 맡는다.
  const companyObj = util.readStoredJson("companyInfo") || {};

  useEffect(() => {
    window.scrollTo(0, 0);
    hospitalParam.cusId = decodeURIComponent(localStorage.getItem("userCusID") || '');
    hospitalParam.famId = decodeURIComponent(storeData.reservationInfo.famId);
    hospitalParam.hosId = decodeURIComponent(storeData.reservationInfo.hosId);
    const companyId = decodeURIComponent(storeData.reservationInfo.companyId);

    // 선택 병원의 capacity items
    api.get(`customer/api/v2/hospitals/${encodeURIComponent(hospitalParam.hosId)}/capacity/items/${new Date().getFullYear()}`).then(res => {
      setAllItems(res.data)
    }).catch(function (error) {
      console.log(error)
    });

    // 선택 병원의 capacity
    api.get(`customer/api/v2/hospitals/${encodeURIComponent(hospitalParam.hosId)}/capacity/capacities/${new Date().getFullYear()}`).then(res => {
      setCapacity(res.data.data.map((v: any) => {
        return {
          classes: v.classes,
          dateName: v.title,
          locdate: v.start.replaceAll(/[-]/ig, ""),
          capacityClassItem: v.capacityClassItem
        };
      }))
    }).catch(function (error) {
      console.log(error)
    });

    // 선택 병원과 접속 회원의 기업간의 제공되는 패키지
    api.get(`customer/api/v2/hospitals/${encodeURIComponent(hospitalParam.hosId)}/companies/${encodeURIComponent(companyId)}/packages`).then(res => {
      setPackagesInfo(res.data.data)
    }).catch(function (error) {
      console.log(error)
    });

    // 선택한 병원 정보
    api.post('customer/api/v1/CU_003_003_2', hospitalParam).then(res => {
      localStorage.setItem('HOS_INFO', JSON.stringify(res.data));
      setIsSatOpen(res.data['satOpen']);
      setSelectHospital(res.data)
    }).catch(function (error) {
      console.log(error)
    });

    // 예약 가능한 패키지 목록
    api.post('customer/api/v1/CU_003_003', hospitalParam).then(res => {
      setPackageListData(res.data)
    }).catch(function (error) {
      console.log(error)
    });

    return () => {
    }
  }, []);

  // 패키지 목록 세팅
  function setPackageListData(data: any) {
    setPackageList(data);
    const closePackageIds: any = getClosedPack(storeData.reservationInfo.date);
    setClosePackageIds(closePackageIds);
  }

  // 마감된 패키지 목록
  function getClosedPack(targetDate: string) {
    let returnArr = [];
    targetDate = targetDate.replaceAll('-', '');
    const capacityClassItems = capacity.filter((v: any) => v.classes === 'inspection-close' && v.locdate === targetDate).map((v: any) => v.capacityClassItem);
    if (capacityClassItems.length > 0) {
      const items = capacityClassItems.map(v => v.item.code);
      const closePackage = packagesInfo.filter((pack: any) =>
        pack.ipClassInfos.filter((clazz: any) => clazz.ipClass !== '기본')
          .some((clazz: any) => {
            const limit = clazz.choiceLimit;
            const closeCount = clazz.piis.filter((pii: any) => items.some(item => item === pii.ipCode && item.isOpen === false)).length;
            const originCount = clazz.piis.length;
            return !(limit <= (originCount - closeCount));
          }));
      const basicClosePackage = packagesInfo.filter((pack: any) =>
        pack.ipClassInfos.filter((clazz: any) => clazz.ipClass === '기본')
          .filter((clazz: any) => clazz.piis.some((pii: any) => {
            return items.some(item => item === pii.ipCode && item.isOpen === false)
          })).length !== 0
      );
      returnArr = Array.from(new Set(basicClosePackage.map((p: any) => p.id).concat(closePackage.map((p: any) => p.id))));
    }

    return returnArr;
  }

  // 선택한 패키지 검사항목
  function choicePackage(e: any) {
    setShowBaseInjection(true);
    setCheckedBoxes([[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
    storeData.setCheckedInjectioList([]);
    const pkgId = e.target.value;
    pakageParam.famId = decodeURIComponent(storeData.reservationInfo.famId);
    pakageParam.pkgId = pkgId;
    storeData.setReservationInfo('pkgId', pkgId);
    //내시경 초기화
    setCloseEndoscopeItems(["D1A2C003","D1A2C004","D1A2C005","E1E1E002","E1E1E003","E1E1E004"])

    api.post('customer/api/v1/CU_003_004', pakageParam).then(res => {
      const injectionData = res.data;
      const injectionByCategory = injectionData.reduce((acc: any, curr: any) => {
        if (curr.ipClass === '기본') setInjectionPrice(curr.price)
        const { category } = curr;
        if (acc[category]) acc[category].push(curr);
        else acc[category] = [curr];
        return acc;
      }, {});
      setInjectionData(injectionData);
      setBaseInjectionByCategory(Object.keys(injectionByCategory));

      // 기본 검사 가격 합산
      const basePrice = injectionData.reduce((sum: any, curr: any) => {
        return curr.ipClass === '기본' ? sum + curr.price : sum;
      }, 0);
      
      // 선택 검사 항목 세팅
      const choiceList = setChoiceInjectionList(injectionData);
      setChoiceList(choiceList);
      storeData.setReservationInfo('basePrice', basePrice);
      storeData.setReservationInfo('addPrice', basePrice);
    }).catch(function (error) {
      console.log(error)
    });
  }

  // 선택, 추가 검사 항목 목록
  function setChoiceInjectionList(injectionData: any) {
    let choiceList = [];

    // 선택검사 항목 어떤게 있고 몇 개인지
    for (var i = 0; i < injectionData.length; i++) {
      if ((injectionData[i].ipClass).indexOf("선택") !== -1 || (injectionData[i].ipClass).indexOf("추가") !== -1) {
        let count = 0;
        for (var j = 0; j < choiceList.length; j++) if (choiceList[j].title === injectionData[i].ipClass) count++;

        if (count === 0) {
          const ijObject = { title: '', id: '', count: '' };
          ijObject.title = injectionData[i].ipClass;
          ijObject.id = encodeURIComponent(injectionData[i].ipClass).replaceAll('%', '');
          ijObject.count = injectionData[i].choiceLimit;
          choiceList.push(ijObject);
          count = 0;
        }
      }
    }

    // 선택검사 알파벳순 정렬
    choiceList.sort(function (a, b) {
      const titleA = a.title.toUpperCase(); // ignore upper and lowercase
      const titleB = b.title.toUpperCase(); // ignore upper and lowercase
      if (titleA < titleB) {
        return -1;
      }
      if (titleA > titleB) {
        return 1;
      }
      return 0;
    });

    const choiceCountLimit = choiceList.filter(item => item.title !== '추가').reduce(function (prev: any, next: any) {
      return prev + next.count;
    }, 0);
    storeData.setChoiceLimitCount(choiceCountLimit);
    return choiceList;
  }


  // 기본검사 항목 선택
  const selectBaseInjection = (event: React.SyntheticEvent, newValue: number) => {
    setBaseInjection(newValue);
  };

  const ENDOSCOPE_CODE = {
    STOMACH_SLEEP: "C1A1A006",
    STOMACH_NO: "C1A1A005",
    COLON_SLEEP: "C1A1A003",
    COLON_NO: "C1A1A002",
  };

  const ENDOSCOPE_REMOVE_CODES = [
    "C1A1A006", // 위 수면
    "C1A1A005", // 위 비수면
    "C1A1A003", // 대장 수면
    "C1A1A002", // 대장 비수면
  ];

  const SLEEP_COST_CODE = {
    STOMACH: "D1A2C004",
    COLON: "D1A2C003",
    BOTH: "D1A2C005",
  };

  const getEndoscopeState = (cb: string[][]) => {

    const has = (code: string) => {
      return Object.values(cb).some((items: any[]) =>
          items.some(item => item.ipCode ===code)
      );
    };
    return {
      stomach: has(ENDOSCOPE_CODE.STOMACH_SLEEP)
          ? "SLEEP"
          : has(ENDOSCOPE_CODE.STOMACH_NO)
              ? "NO"
              : "NONE",

      colon: has(ENDOSCOPE_CODE.COLON_SLEEP)
          ? "SLEEP"
          : has(ENDOSCOPE_CODE.COLON_NO)
              ? "NO"
              : "NONE",
    };
  };

  const isMixedSleepState = (state: any) => {
    return (
        (state.stomach === "SLEEP" && state.colon === "NO") ||
        (state.stomach === "NO" && state.colon === "SLEEP")
    );
  };

  const removeEndoscopeCodes = (cb: any) => {
    Object.keys(cb).forEach(key => {
      cb[key] = cb[key].filter(
          (item: any) => !ENDOSCOPE_REMOVE_CODES.includes(item.ipCode)
      );
    });

    alert("위내시경과 대장내시경 동시 진행시\n" +
        "수면/비수면 방식 통일이 필요합니다.")
  };

  const updateSleepCostCloseItems = (rawState: any) => {
    const closeItems = ["D1A2C003", "D1A2C004", "D1A2C005"];

    if (rawState.stomach === "NO" && rawState.colon !== "NO") {
      return closeItems.filter(c => c !== "D1A2C004");
    }
    if (rawState.colon === "NO" && rawState.stomach !== "NO") {
      return closeItems.filter(c => c !== "D1A2C003");
    }
    if (rawState.stomach === "NO" && rawState.colon === "NO") {
      return closeItems.filter(c => c !== "D1A2C005");
    }
    return closeItems;
  };

  const removeClosedItemsFromCb = (cb: any, closeItems: string[]) => {
    Object.keys(cb).forEach(key => {
      cb[key] = cb[key].filter(
          (item: any) => !closeItems.includes(item.ipCode)
      );
    });
  };

  const updateSleepManageCloseItems = (normalizedState: any) => {
    const closeItems = ["E1E1E002", "E1E1E003", "E1E1E004"];

    if (normalizedState.stomach === "SLEEP" && normalizedState.colon === "SLEEP") {
      return []
    }
    if (normalizedState.stomach === "SLEEP") {
      return closeItems.filter(c => c !== "E1E1E003");
    }
    if (normalizedState.colon === "SLEEP") {
      return closeItems.filter(c => c !== "E1E1E004");
    }
    return closeItems;
  };

  type InspectionItem = {
    ipCode: string;
    price: number;
  };
  type CheckedBoxes = Record<number, InspectionItem[]>;

  const getNormalizedEndoscopeState = (cb: CheckedBoxes) => {
    const has = (code: string) =>
        Object.values(cb).some((items) =>
            items.some(item => item.ipCode === code)
        );

    const stomachSleep =
        has(ENDOSCOPE_CODE.STOMACH_SLEEP) ||
        (has(ENDOSCOPE_CODE.STOMACH_NO) &&
            has(SLEEP_COST_CODE.STOMACH)) ||
        has(SLEEP_COST_CODE.BOTH);

    const colonSleep =
        has(ENDOSCOPE_CODE.COLON_SLEEP) ||
        (has(ENDOSCOPE_CODE.COLON_NO) &&
            has(SLEEP_COST_CODE.COLON)) ||
        has(SLEEP_COST_CODE.BOTH);

    return {
      stomach: stomachSleep ? "SLEEP" : has(ENDOSCOPE_CODE.STOMACH_NO) ? "NO" : "NONE",
      colon: colonSleep ? "SLEEP" : has(ENDOSCOPE_CODE.COLON_NO) ? "NO" : "NONE",
    };
  };

  const normalizeSleepCostByNoSleep = (cb: any, rawState: any) => {
    Object.keys(cb).forEach(key => {
      cb[key] = cb[key].filter((item: any) => {
        // 위 수면비용인데, 위 비수면이 없으면 제거
        if (
            item.ipCode === "D1A2C004" &&
            rawState.stomach !== "NO"
        ) {
          return false;
        }

        // 대장 수면비용인데, 대장 비수면이 없으면 제거
        if (
            item.ipCode === "D1A2C003" &&
            rawState.colon !== "NO"
        ) {
          return false;
        }

        // 위+대장 수면비용인데, 둘 다 비수면이 아니면 제거
        if (
            item.ipCode === "D1A2C005" &&
            !(rawState.stomach === "NO" && rawState.colon === "NO")
        ) {
          return false;
        }

        return true;
      });
    });
  };

  const calculateAddPrice = (cb: CheckedBoxes) => {
    let total = 0;

    Object.values(cb).forEach((items: any[]) => {
      items.forEach(item => {
        total += Number(item.price || 0);
      });
    });

    return total;
  };


  // 선택, 추가 검사 항목 클릭 이벤트
  const handleCheckedBoxes = (isChecked: any, index: any, name: any) => {
    let cb = { ...checkedBoxes };
    Object.values(cb).map(((item: any, ii: any) => {
      if (index === ii) {
        if (isChecked) {
          cb[ii] = cb[index].concat(name);
        } else {
          cb[ii] = cb[index].filter((x: any) => x !== name);
        }
      }
    }))
    // raw 상태 계산 (비수면 기준)
    let rawState = getEndoscopeState(cb);

    // 2정규화 상태 계산 (비수면 + 수면비용 = 수면)
    let normalizedState = getNormalizedEndoscopeState(cb);

    // 혼합 상태면 내시경 코드 제거
    if (isMixedSleepState(normalizedState)) {
      removeEndoscopeCodes(cb);
    }

    // cb 변경 → 상태 재계산
    rawState = getEndoscopeState(cb);
    normalizedState = getNormalizedEndoscopeState(cb);

    // 비수면 해제 시 수면비용 자동 제거 (이번 개선 포인트)
    normalizeSleepCostByNoSleep(cb, rawState);

    // 수면비용 차단 계산 (rawState 기준)
    const sleepCostClose = updateSleepCostCloseItems(rawState);
    // 수면관리비 차단 계산 (normalizedState 기준)
    const sleepManageClose = updateSleepManageCloseItems(normalizedState);

    // 전체 차단 목록
    const closeItems = [
      ...sleepCostClose,
      ...sleepManageClose,
    ];

    // cb에서 제거해야 하는 건 "수면관리비만"
    removeClosedItemsFromCb(cb, closeItems.filter(code => code.startsWith("E1E1")));

    // 반영
    setCheckedBoxes(cb);
    setCloseEndoscopeItems(closeItems);

    let tp: any = [];
    Object.values(cb).map(((item: any) => {
      for (var i = 0; i < item.length; i++) {
        tp.push(item[i])
      }
    }))
    storeData.setCheckedInjectioList(tp);

    // 선택(추가) 항목 비용만 계산
    const choicePrice = calculateAddPrice(cb);

    // 기본 비용 유지 + 선택 비용 합산
    const basePrice = Number(storeData.reservationInfo.basePrice || 0);
    const newAddPrice = basePrice + Number(choicePrice || 0);

    storeData.setReservationInfo('addPrice', newAddPrice);
  };



  return (
    <Container maxWidth="sm" sx={{ p: 0, height: '100%', pb: 5 }}>
      <Card sx={{ minWidth: 320, bgcolor: '#FFFBF8', }}>
        <Img alt="" src={selectHospital['fileName']} />

        <CardContent sx={{ m:0}}>
          <Typography gutterBottom variant="h6" component="div">
            {selectHospital['name']}
          </Typography>
          <Typography variant="body2" color="#555">
            {selectHospital['address']}
          </Typography>
          <Typography variant="body2" color="#555">
            {selectHospital['buildingNum']}
          </Typography>

          <Stack direction="row" spacing={1} sx={{ mt: 2, mb: 1, flexWrap:'wrap' }}>
            <Chip size="small" sx={{ bgcolor: '#DBD4E5', color: '#4A3B96', m: '2px !important' }} label={selectHospital['region']} />
            <Chip size="small" sx={{ bgcolor: '#DBD4E5', color: '#4A3B96', m: '2px !important' }} label={selectHospital['phone']} />
            {util.strNull(selectHospital['operatingHours']) !== '' ? (
              selectHospital['operatingHours'].split('\n').map((item: any) => (
                <Chip size="small" sx={{ bgcolor: '#DBD4E5', color: '#4A3B96', m: '2px !important' }} label={item} />
              ))
            ) : (null)
            }
          </Stack>
            {util.strNull(selectHospital['notice']) !== '' ? (
              selectHospital['notice'].split('\n').map((item: any) => (
                <Typography variant="body2" color="#555" sx={{mt:1}}>
                  {item}
                </Typography>
              ))
            ) : (null)
            }
            {util.strNull(selectHospital['plusInfo']) !== '' ? (
              selectHospital['plusInfo'].split('\n').map((item: any) => (
                <Typography variant="body2" color="#555" sx={{mt:1, fontWeight:700}}>
                  {item}
                </Typography>
              ))
            ) : (null)
            }
        </CardContent>
      </Card>

      <FormControl component="fieldset" sx={{ p: '0 15px', width: '100%', boxSizing: 'border-box', mt: 3 }}>
        <FormLabel component="legend" sx={{mb:2, fontWeight:700}}>검진 유형 선택</FormLabel>

        <RadioGroup
          row
          aria-labelledby="demo-row-radio-buttons-group-label"
          name="row-radio-buttons-group"
          /*defaultValue={storeData.reservationInfo.pkgId}*/
          onChange={choicePackage}
          sx={{ flex: 1, flexDirection: 'column' }}
        >

          {packageList.map((pk: any, index) => (
            <React.Fragment>
              <Stack sx={{bgcolor:'#fff', p:1, mb:1, borderRadius:'4px', boxShadow:'0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)'}}>
                <FormControlLabel key={index} value={pk['pkgId']}
                  control={<Radio sx={{ color: '#888', '&.Mui-checked': { color: '#ef8322' }, }} />}
                                  label={
                                    <Box
                                        sx={{
                                          display: 'flex',
                                          width: '100%',
                                          justifyContent: 'space-between',
                                          alignItems: 'center',
                                        }}
                                    >
                                      <Box sx={{ minWidth: 100 }}>
                                        {pk['pkgName']}
                                      </Box>
                                      <Box sx={{ fontWeight: 600, color: '#0d6703' }}>
                                        &nbsp;&nbsp;{(Number(pk['price'] || 0) + Number(companyObj.rebate_price || 0)).toLocaleString()} 원
                                      </Box>
                                    </Box>
                                  }
                  disabled={closePackageIds.includes(pk['pkgId'])}
                  sx={{ flex: 1, m: 0 }}
                />
              </Stack>
            </React.Fragment>
          ))}

        </RadioGroup>

      </FormControl>

      <FormControl component="fieldset" sx={{ p: '0 15px', width: '100%', boxSizing: 'border-box', mt: 3,display: showBaseInjection ? 'block' : 'none'  }} >
        <FormLabel component="legend" sx={{fontWeight:700}}>기본검사</FormLabel>

        <Box sx={{ width: '100%', bgcolor: '#fff', mt: 2, p: 0 }}>
          <Tabs onChange={selectBaseInjection} centered variant="scrollable"  scrollButtons="auto" >
            {baseInjectionByCategory.map((base: any, index: any) => (
              <Tab key={index} label={base + '(' + injectionData.filter((item: any) => item.category === base && item.ipClass === '기본').length + ')'} value={base} />
            ))}
          </Tabs>
        </Box>

        <Box sx={{ flexGrow: 1, marginBottom: 2, display: showBaseInjection ? 'block' : 'none', }}>
          <Grid container columns={{ xs: 3 }} sx={{ bgcolor: '#fff' }}>
            {injectionData.filter((item: any) => item.category === baseInjection && item.ipClass === '기본').map((base: any, index: any) => (
              <Grid item xs={1} key={index}>
                <Item
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    boxSizing: 'border-box',
                    height: '100%',
                    boxShadow: 'none',
                    borderRadius: 0,
                    borderRight: '1px solid #eee',
                    borderTop: '1px solid #eee',
                    p: '8px 0'
                  }}
                >{base.inspection}</Item>
              </Grid>
            ))}
          </Grid>
        </Box>
      </FormControl>

      <Box sx={{ display: showBaseInjection ? 'block' : 'none', p: '0 15px' }}>
        <FormControl component="fieldset" sx={{ mt:1}}>
          <FormLabel component="legend" sx={{fontWeight:700, mb:2 }}>선택검사</FormLabel>
        </FormControl>

        {choiceList.map((choice: any, index: any) => (
          // <CardExpand choice={choice} index={index} injectionData={injectionData} checkedBoxes={checkedBoxes} handleCheckedBoxes={handleCheckedBoxes} />
          <CardExpand choice={choice} index={index} injectionData={injectionData} checkedBoxes={checkedBoxes} handleCheckedBoxes={handleCheckedBoxes} closeEndoscopeItems={closeEndoscopeItems}/>
        ))}
      </Box>

      <FormControl component="fieldset" sx={{ m: 2, mt:3, display: showBaseInjection ? 'block' : 'none' }}>
        <FormLabel component="legend" sx={{fontWeight:700,}}>선택/추가 항목 확인</FormLabel>
        <List dense={false} sx={{ bgcolor: '#fff', p: 0, borderRadius: '4px', mt: 2, display: 'flex', flexDirection: 'column', '& li:last-child': { border: 'none' }, boxShadow:'0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)' }} >
          {storeData.checkedInjectioList.map((ij: any, index: any) => (
            <ListItem sx={{ flexDirection: 'column', alignItems: 'flex-start', borderBottom: '1px solid #eee', p: 2 }}>
              <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                <Typography  sx={{ fontSize: 14, color: '#333', mt: '5px', fontWeight: 700  }}>
                  {ij.inspection + ' '}
                </Typography>
                <Typography sx={{ ml: 'auto', fontSize: 16, fontWeight: 700 }}>
                  {(ij.price).toLocaleString('ko-KR') + '원'}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Typography sx={{ fontSize: 14, color: '#555', mt: '5px' }}>
                  {ij.memo}
                </Typography>
              </Box>

            </ListItem>


          ))}
        </List>
      </FormControl>

      <CardContent sx={{ mt: 5, mb:0, display: showBaseInjection ? 'block' : 'none', textAlign: 'center', bgcolor:'#fff', borderTop:'1px solid #ddd', borderBottom:'1px solid #ddd' }}>
        <Typography component="div" sx={{ fontWeight: 700, mb: 2 }}>
          총 추가금액
        </Typography>
        <Typography gutterBottom variant="h6" component="div" sx={{ bgcolor: '#f1f2f4', p: 2, borderRadius: '32px', color: '#bf0000', fontWeight: 700, boxShadow:'inset 0px 2px 1px -1px rgba(0,0,0,0.2), inset 0px -1px 1px 0px rgba(0,0,0,0.14), inset 0px 0px 3px 0px rgba(0,0,0,0.12)'}}>
          {storeData.reservationInfo.addPrice.toLocaleString('ko-KR') + '원'}
        </Typography>
      </CardContent>
    </Container>
  );
}

export default SetItem;